// その日にいくら使ったか
//
// 歩数サマリーと並べて、行動の記録と一緒に見られるようにする。
// レシートの無いカード利用も保険として合計に入れる。
import { ReceiptText } from 'lucide-react'

import type { CardTransaction } from '@/api/types/card-transaction'
import type { ReceiptSummary } from '@/api/types/receipt'

type Props = {
  receipts: ReceiptSummary[]
  cardTransactions?: CardTransaction[]
}

export const SpendingSummary = ({ receipts, cardTransactions = [] }: Props) => {
  if (receipts.length === 0 && cardTransactions.length === 0) return null

  // 金額が読めていないレシートは合計に入れられないので、件数だけ添えて分かるようにする
  const receiptTotal = receipts.reduce((sum, receipt) => sum + (receipt.total_amount ?? 0), 0)
  const cardTotal = cardTransactions.reduce((sum, tx) => sum + tx.amount, 0)
  const unknownCount = receipts.filter((receipt) => receipt.total_amount === null).length
  const notes = [
    unknownCount > 0 && `${unknownCount}件は金額不明`,
    cardTransactions.length > 0 && `${cardTransactions.length}件はカードの記録のみ`,
  ].filter(Boolean)

  return (
    <div className="flex items-center gap-1.5 text-sm">
      <ReceiptText className="size-4 text-amber-600" />
      <span className="font-medium tabular-nums">¥{(receiptTotal + cardTotal).toLocaleString()}</span>
      <span className="text-xs text-muted-foreground">
        {receipts.length + cardTransactions.length}件{notes.length > 0 && `（${notes.join('、')}）`}
      </span>
    </div>
  )
}
